import React, { createContext, useCallback, useContext, useState } from "react";

const PopupContext = createContext({ open: false, openPopup: () => {}, closePopup: () => {} });

export function PopupProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openPopup = useCallback(() => setOpen(true), []);
  const closePopup = useCallback(() => setOpen(false), []);
  return (
    <PopupContext.Provider value={{ open, openPopup, closePopup, setOpen }}>
      {children}
    </PopupContext.Provider>
  );
}

export function usePopup() {
  return useContext(PopupContext);
}
